import algoliasearch from 'algoliasearch'

import { environment } from '@config/environment'

export const algoliaClient = algoliasearch(environment.algolia.appId, environment.algolia.publicApiKey)

export const adminAlgoliaClient = algoliasearch(environment.algolia.appId, environment.algolia.writeApiKey)
